<template>
  <div class="main-content">
    <Nav></Nav>
    <canvas id='mycanvas' v-show='false' ></canvas>
    <div class="center-body">
      <div class="row" style="margin-top: 30px;">
        <Breadcrumb separator=">">
          <BreadcrumbItem to="/">{{ $t("lang.product") }}</BreadcrumbItem>
          <BreadcrumbItem to="/filter">
            {{ $t("lang.productcenter") }}
          </BreadcrumbItem>
          <BreadcrumbItem>
            <span @click="toclassify" style="cursor: pointer" class="nav-tit">{{
              $t("lang.classifylist")
            }}</span>
          </BreadcrumbItem>
          <BreadcrumbItem>{{ $t("lang.prodeuctdetail") }}</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <!-- <div class="row" style="padding-left: 15px;">
        <div class="item" style="align-items: center;">
          <span style="font-size: 18px;color: #333;cursor: pointer;">
            {{ $t("lang.prodeuctdetail") }}
          </span>
        </div>
        <div
          class="item"
          style="justify-content: flex-end;align-items: center;"
        >
          <Button @click="goback">{{ $t("lang.back") }}</Button>
        </div>
      </div> -->
      <div class="row" style="margin-top: 25px;margin-bottom:40px">
        <div
          class="item"
          style="flex: 1;align-items: center;overflow: hidden;flex-direction: column;"
        >
          <div style="width: 500px;height: 500px;margin-bottom:20px;">
            <img
              :src="pic"
              style="display:block;width: 100%;height:100%"
              v-show="this.isIndex == 2"
            />

            <img
              v-if="detail.properties && detail.properties.tuzhi"
              :src="detail.properties.tuzhi"
              style="display:block;width: 100%;height:100%"
              v-show="this.isIndex == 3"
            />
            <div
              v-if="detail.properties && detail.properties.video"
              class="video-box"
              v-show="this.isIndex == 1"
            >
              <video
                id="upvideo"
                width="500"
                height="500"
                :src="detail.properties.video"
                style="width: 100%;border-radius: 5px;"
                controls
                type="video/mp4"
              ></video>
            </div>
          </div>
          <div style="display:flex;" v-if="count>1">
            <!-- <Icon
              type="ios-arrow-back"
              style="line-height:120px;font-size: 35px;font-weight: 100;"
              @click="prevIndex"
            /> -->
            <div class="detail-text" @click="nowIndex(1)" v-if="detail.properties.video">
              <!--{{ $t("lang.productVideo") }}-->
              <!--<img :src="videoImg" style="display:block;width: 100%;height:100%" />-->
               <video
                id="upvideo"
                :src="detail.properties.video"
                style="width: 100%;height: 100%;"
                type="video/mp4"
              ></video>
              
            </div>
            <div class="detail-text" @click="nowIndex(2)" v-if="pic">
              <!-- {{ $t("lang.picture") }} -->
              <img :src="pic" style="display:block;width: 100%;height:100%"/>
            </div>
            <div
              class="detail-text"
              @click="nowIndex(3)"
              v-if="detail.properties && detail.properties.tuzhi"
            >
              <!-- {{ $t("lang.image") }} -->
              <img
                :src="detail.properties.tuzhi"
                style="display:block;width: 100%;height:100%"
              />
            </div>
            <!-- <Icon
              type="ios-arrow-forward"
              style="line-height:120px;font-size: 35px;font-weight: 100;"
              @click="nextIndex"
            /> -->
          </div>
        </div>
        <div class="col" style="padding-left: 100px;flex: 1;font-size: 16px;">
          <div
            style="font-size:16px;color:#666;margin-bottom:40px;display:flex;"
          >
            <div class="item-no" style="align-items: center;margin-right: 8px;">{{ $t("lang.productname") }} :</div>
            <span style="font-size:24px;color:#333;">{{ detail.name }}</span>
          </div>
          <div v-if="detail.properties"></div>
          <div
            style="display: flex; justify-content: flex-start;line-height: 2rem;"
            v-if="detail.descs"
          >
            {{ $t("lang.briefintroduction") }} :
            <div class="col">
              <div
                style="flex: 1 1 0%;line-height: 2rem;display: flex;justify-content: flex-start;"
                v-for="(value, index) in detail.descs"
                :key="index"
              >
	              <span
                  style="height: 10px;width: 10px;border-radius: 50%;background: rgb(225, 0, 19);margin: 10px;/* display: block; */"
                ></span>
                <p style="flex: 1;display: flex;justify-content: flex-start;align-items: center;line-height: 2rem;">{{
                  value }}</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div
        v-if="detail.detail"
        class="item"
        style="flex: 4;overflow: hidden;justify-content: center;"
      >
        <img :src="detail.detail" style="width: 100%;"/>
      </div>
      <Table
        v-if="detail.type === 20"
        :columns="showColumns"
        :data="specialList"
        border
        max-height="500"
      ></Table>
      <div class="prduct-box">
        <div class="row">
          <div
            class="item"
            style="font-size: 24px;color: #333;font-weight: 400;"
          >
            {{ $t("lang.recommend") }}
          </div>
        </div>
        <div
          class="wrap-row"
          style="margin-bottom: 15px;margin-left:-1%;margin-right:-1%;"
        >
          <div
            class="col-no"
            style="width: 23%;margin: 0 1%;margin-top: 15px;"
            v-for="pro in recomondList"
            :key="pro.id"
            @click="toDetail(pro)"
          >
            <div
              style="width: 100%;height: 270px;background: #666;overflow: hidden;display: flex;justify-content: center;align-items: center;"
            >
              <img :src="pro.pic" style="width: 100%;height: 270px;"/>
            </div>
            <div
              class="item"
              style="justify-content: center;font-size: 14px;color: #333;font-weight:400;margin-top: 10px;"
            >
              {{ pro.value }}{{ pro.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from "./nav.vue";
  export default {
    name: "App",
    components: {
      Nav,
    },
    data() {
      return {
        count: 0,
        isIndex: 1,
        type: 1, //1表示产品系列详情，0表示产品详情
        detail: {},
        lwidth: "",
        params: {
          productId: "",
          specialKey: "ww",
          specialValue: "",
        },
        pic: "",
        specialId: "",
        id: "",
        specialList: [],
        recomondList: [],
        showItem: [
          {
            id: 98,
            values: ["code", "ll", "ww", "mb", "mlk", "mll", "mln"],
          },
          {
            id: 99,
            values: ["code", "ll", "ww", "mb", "mlk", "mll", "mln"],
          },
          {
            id: 100,
            values: ["code", "ll", "ww", "mb", "nb", "mlk", "mll", "mln"],
          },
          {
            id: 105,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
          {
            id: 106,
            values: ["code", "ll", "ww", "mb", "hd", "mlk", "mll"],
          },
          {
            id: 107,
            values: ["code", "ll", "ww", "tm", "mlk", "mll"],
          },
          {
            id: 108,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
          {
            id: 109,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
          {
            id: 111,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
          {
            id: 112,
            values: ["code", "ll", "ww", "mb", "mad", "mlk", "mll"],
          },
          {
            id: 113,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
          {
            id: 114,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
          {
            id: 115,
            values: ["code", "ll", "ww", "mb", "mlk", "mll"],
          },
        ],
        showColumns: [],
        columns: [
          {
            title: "Item",
            key: "code",
            align: "center",
          },
          {
            title: "Length\nL\nmm(inch)",
            key: "ll",
            align: "center",
          },
          {
            title: "Width\nW\nmm(inch)",
            key: "ww",
            align: "center",
          },
          {
            title: "Max. Bundle Dia.\nE\nmm(inch)",
            key: "mb",
            align: "center",
          },
          {
            title: "Thickness\nmm(inch)",
            key: "tm",
            align: "center",
          },
          {
            title: "Hole Diameter\nmm(inch)",
            key: "hd",
            align: "center",
          },
          {
            title: "Mini. Bundle Dia.\nmm (inch)",
            key: "nb",
            align: "center",
          },
          {
            title: "Marker Area Dia.\nLength x Width \n(mm)",
            key: "mad",
            align: "center",
          },
          {
            title: "Min Loop \nTensile \nStrength(Kgs)",
            key: "mlk",
            align: "center",
          },
          {
            title: "Min Loop \nTensile \nStrength(Lb)",
            key: "mll",
            align: "center",
          },
          {
            title: "Min Loop \nTensile \nStrength(N)",
            key: "mln",
            align: "center",
          },
        ],
      };
    },
    methods: {
      nowIndex(index) {
        this.isIndex = index;
      },
      prevIndex() {
        if (this.isIndex > 1) {
          this.isIndex = this.isIndex - 1;
        } else {
          this.isIndex = 3;
        }
      },
      nextIndex() {
        if (this.isIndex < 3) {
          this.isIndex = this.isIndex + 1;
        } else {
          this.isIndex = 1;
        }
      },
      toDetail(list) {
        var u = this.$util.toRecom(list);
        window.scrollTo(0, 0);
        if (u === "classify") {
          if (list.id === 101 || list.type === 47) {
            this.$localstorage.setStore("detail_productId", list.id);
            this.store_reload();
          } else {
            this.$router.push(u);
          }
        } else {
          this.store_reload();
        }
      },
      goback() {
        history.back();
      },
      recomond() {
        var self = this;

        this.$api.api
          .xinlongComond({productId: self.detail.id, width: self.lwidth})
          .then(function (response) {
            if (response.data.code == 200) {
              self.recomondList = response.data.data;
            }
          });
      },
      proDetail() {
        let self = this;
        self.$api.api.proDetail(this.params.productId).then(function (response) {
          self.count = 0;
          if (response.data.code === 200) {
            self.detail = response.data.data;
            self.detail.descs = self.detail.desc
              ? self.detail.desc.split("|")
              : [];
            if (self.detail.type === 20) {
              self.proSpecialDetail();
            } else {
              self.pic = self.detail.pic;
              if (self.pic) {
                self.count++;
              }
              self.recomond(self.detail.type);
            }
            if (!self.detail.properties.video) {
              self.isIndex = 2
            } else {
              self.count++;
            }

            if (self.detail.properties && self.detail.properties.tuzhi) {
              self.count++;
            }
          }
        });
      },
      toclassify() {
        this.$util.toClassify(this.detail);
        this.$router.push("classify");
      },
      proSpecialDetail() {
        let self = this;
        let item = {};
        if (self.specialId) {
          self.$api.api
            .proSpecialDetailById(self.specialId)
            .then(function (response) {
              if (response.data.code === 200) {
                self.specialList = response.data.data;
                if (self.specialList.length > 0) {
                  self.pic = self.specialList[0].pic;
                  if(self.pic){
                    self.count++;
                  }
                  if (self.specialList[0].ww) {
                    self.lwidth = self.specialList[0].ww
                      .replace("（", "(")
                      .split("(")[0];
                  }
                }
                self.recomond();

                self.showColumns = [];
                item = self.$lodash.find(self.showItem, function (o) {
                  return o.id === self.params.productId;
                });
                if (!item) {
                  item = {
                    values: ["code", "ll", "ww", "mb", "nb", "mlk", "mll", "mln"],
                  };
                }
                self.columns.forEach((c) => {
                  if (item.values.indexOf(c.key) >= 0) {
                    self.showColumns.push(c);
                  }
                });
              }
            });
        } else {
          self.$api.api.proSpecialDetail(self.params).then(function (response) {
            if (response.data.code === 200) {
              self.specialList = response.data.data;
              if (self.specialList.length > 0) {
                self.pic = self.specialList[0].pic;
                if(self.pic){
                  self.count++;
                }
                if (self.specialList[0].ww) {
                  self.lwidth = self.specialList[0].ww
                    .replace("（", "(")
                    .split("(")[0];
                }
              }
              self.recomond();
              self.showColumns = [];
              item = self.$lodash.find(self.showItem, function (o) {
                return o.id === self.params.productId;
              });
              if (!item) {
                item = {
                  values: ["code", "ll", "ww", "mb", "nb", "mlk", "mll", "mln"],
                };
              }
              self.columns.forEach((c) => {
                if (item.values.indexOf(c.key) >= 0) {
                  self.showColumns.push(c);
                }
              });
            }
          });
        }
      },
      store_reload() {
        let self = this;
        if (this.$localstorage.getStore("specialId")) {
          this.specialId = this.$localstorage.getStore("specialId");
        } else if (this.$localstorage.getStore("groupValue")) {
          self.params.specialValue = this.$localstorage.getStore("groupValue");
          self.lwidth = self.params.specialValue;
        }
        self.params.productId = this.$localstorage.getStore("detail_productId");
        this.proDetail();
      },
    },
    mounted() {
      this.store_reload();
    },
    destroyed() {
      this.$localstorage.removeStore("specialId");
      this.$localstorage.removeStore("groupValue");
      this.$localstorage.removeStore("detail_productId");
    },
  };
</script>

<style scoped>
  .main-content {
    min-height: 100%;
    width: 100%;
    min-width: 1200px;
    margin: 0 auto;
    display: block;
    position: absolute;
    background: #f7f7f7;
    margin-top: 135px;
  }

  .center-body {
    width: 1200px;
    margin: 0 auto;
  }

  .prduct-box {
    margin-top: 40px;
    padding: 15px 0;
  }

  .detail-text {
    width: 120px;
    height: 120px;
    background-color: #f0f0f0;
    line-height: 120px;
    text-align: center;
    font-size: 16px;
    color: #0b0a0a;
    margin: 0 16px;
  }

  .nav-tit {
    color: #515a6e;
  }

  .nav-tit:hover {
    color: #2d8cf0;
  }
</style>
